import { COOKIE_NAME_SESSION_ID } from '../constants'
import { useStore } from '../providers/store'
import { useCookiesByGroup } from './useCookiesByGroup'

export const useSessionId = () => {
	const { groupId } = useStore()
	const [{ [COOKIE_NAME_SESSION_ID]: cookieSessionId }, setCookiesByGroup] = useCookiesByGroup([groupId])

	if (!cookieSessionId) {
		const newSessionId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
		setCookiesByGroup(COOKIE_NAME_SESSION_ID, newSessionId, {
			session: true,
			expires: null, // force expire to null or session won't be set
		})
		return newSessionId
	} else {
		return cookieSessionId
	}
}
